window.setupStatusPage = function(embedCode) {
    const loadStatusPageEmbed = function() {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "https://" + embedCode + ".statuspage.io/embed/script.js";
        document.body.appendChild(script);
    };
    if (embedCode) window.addEventListener("load", loadStatusPageEmbed, false);
};

//# sourceMappingURL=member-portal-elm.518bd3c6.js.map
